export const links = [
    {
        id: 0,
        link: '/',
        title: 'Inicio',
    },
    {
        id: 1,
        link: '/characters',
        title: 'Personagens',
    },
    {
        id: 2,
        link: '/comics',
        title: 'Quadrinhos',
    },
    {
        id: 3,
        link: '/creators',
        title: 'Criadores',
    },
    {
        id: 4,
        link: '/keys',
        title: 'Suas Chaves',
    },
];
